import React, { useEffect, useState } from "react";
import { useChartContext } from "../../Context/ChartsContext";
import LineRaceChart from "../../CHARTS/LineRaceChart";

import { getDaysInMonth } from "../../Utilitie";
const PunctualityMexpPass = () => {
  const { bestSheetDataObj } = useChartContext();
  const [visibleTable, setVisibleTable] = useState(null);
  const [bestSheetData, setBestSheetData] = useState(null);
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    setVisibleTable(bestSheetDataObj.visibleTable);
    setBestSheetData(bestSheetDataObj.bestSheetData);
  }, [bestSheetDataObj]);
  useEffect(() => {
    if (bestSheetData && visibleTable) {
      let newChartData = [];

      Object.entries(visibleTable).forEach(([key, value]) => {
        if (value) {
          bestSheetData.forEach((fyObj) => {
            if (fyObj.F_YEAR === key) {
              fyObj.months.forEach((monthObj) => {
                let days = getDaysInMonth(
                  fyObj.F_YEAR,
                  monthObj.A_MONTH.toUpperCase()
                );
                newChartData.push({
                  time: `${monthObj.A_MONTH}\n${fyObj.F_YEAR.replace(
                    "_",
                    "-"
                  )}`,
                  MEXP: monthObj.data.PUN_MAIL,
                  PASS: monthObj.data.PUN_PASS,
                  LDG_WGN: Number(monthObj.data.LDG_WGN).toFixed(0),
                });
              });
            }
          });
        }
      });

      setChartData(newChartData);
    }
  }, [visibleTable, bestSheetData]);

  return (
    <div>
      <div className="bg-dark text-white p-1">
        <h5>
          Punctuality of MEXP and PASS =
          {visibleTable &&
            Object.entries(visibleTable).map(([key, value], index) => {
              return (
                <React.Fragment key={index}>
                  {value ? `${key.replace("_", "-")}, ` : null}
                </React.Fragment>
              );
            })}
        </h5>
      </div>
      <LineRaceChart
        data={chartData}
        title={"MEXP,PASS, punctuality performance graph"}
      />
    </div>
  );
};

export default PunctualityMexpPass;
